const lang = {
    'headline': 'Gogoro® Privacy & Cookie Policy',
    'updated': [
        'Last Updated: June 1, 2022',
    ],
    'privacy': {
        'subheading': 'Privacy Policy',
        'summary': [
            'Gogoro Inc. and its affiliates and/or subsidiaries (collectively, “Gogoro” or “Gogoro Group” or “We”). Your privacy is important to Gogoro. Gogoro has developed this privacy policy (“Gogoro Privacy Policy”) to protect the information that we collected at the time when you use Gogoro’s website (the“Website”) or Gogoro’s products and services (“Product/ Service”). Below please find how Gogoro would collect, process, store, use, and under certain conditions, disclose, share, or transfer your personal information and non-personal information. You understand and agree that by using the App, you will be deemed not to reject but to accept the Gogoro Privacy Policy.',
        ],
        'sections': [{
            'title': 'I have read through and fully understand the Gogoro Privacy Policy. I hereby agree and authorize Gogoro to collect, process and use my personal data accordingly.',
        }, {
            'title': 'I fully understand that, in the course of providing services, Gogoro will inevitably receive information which cannot be linked to my identification ("Non-personal Data"), including, but not limited to, usage time, mileage, location, and real-time localization and mapping of Gogoro Network® smart battery ("Usage Information"). I hereby agree and authorize Gogoro to collect and use my Non-personal Data, or collect and use my Non-personal Data after combining it with my personal data which can be linked to my identification ("Personal Data"), for Gogoro, Gogoro\'s affiliates, or third parties which are commissioned by Gogoro or are in collaboration with Gogoro to process or use such data in the country or region where they are located, or for government, non-profit organizations or academic institutions to process or use such data for purposes of academic research or public interest in the country or region where they are located.',
        }, {
            'title': 'I agree that Gogoro is entitled to amend the Gogoro Privacy Policy at its own discretion. Gogoro may inform me of the amendment thereto in oral or written form, by telephone, text message, email, facsimile, electronic documents or in any other manner which provides me with access to such information (including but not limited to providing me a link, by the foregoing means, to the website on which the Notification is specified). If we change or update Gogoro Privacy Policy, we will indicate that changes have been made by updating the effective date of Gogoro Privacy Policy. Gogoro encourages you to review Gogoro Privacy Policy from time to time to make sure you understand how any personal information you provided may be used.',
        }, {
            'title': 'Collection, Processing and Use of Personal Data',
            'description': 'Gogoro informs all consumers (hereinafter referred to as "you") of the following matters in accordance with Article 8 of the Taiwan Personal Data Protection Act:',
            'sections': [{
                'title': 'The specific purpose of collection of Personal Data:',
                'description': 'The specific purposes for Gogoro to collect Personal Data are as follows:',
                'sections': [{
                    'description': 'To offer various services provided by Gogoro. If you agree to use certain services provided by us, your Personal Data, such as geographic location, will be obtained by means of localization (including real-time localization and mapping), which may be used in the ways stipulated in Consent Letter and related terms of service;',
                }, {
                    'description': 'Marketing purposes such as recommendation of products or services provided by Gogoro and third parties which are in collaboration with Gogoro;',
                }, {
                    'description': 'To combine your Personal Data with your information provided by third parties that are in collaboration with Gogoro, or to provide your Personal Data to such third parties within the necessary scope of collaboration;',
                }, {
                    'description': 'Collection, processing and use of your Personal Data in accordance with legal obligations, contractual or quasi-contractual relationships or any other legal relations, and to exercise or claim the rights or to enforce the procedures in accordance with the contract;',
                }, {
                    'description': 'For business as stipulated in business registration items or articles of incorporation of Gogoro or any other purpose permitted by law;',
                }, {
                    'description': 'Any other purposes for Gogoro\'s business or operations management needs;',
                }, {
                    'description': 'Courts, prosecutors, police agencies, motor vehicle offices or other administrative agencies, based on laws, orders, judgments, sanctions or other statutory investigation procedures, requesting Gogoro to provide your Personal Data;',
                }, {
                    'description': 'Other specific purposes as stipulated in "Special Purposes of Personal Data Protection Act and Types of Personal Data" promulgated by the Taiwan Ministry of Justice (the "Types Classification Guidance") as follows:',
                    'sections': [{
                        'description': '040 "Marketing"',
                    }, {
                        'description': '063 "Collection or processing of personal data under its legal obligations by non-government agency"',
                    }, {
                        'description': '069 "Contract, quasi-contract or other legal relation matters"',
                    }, {
                        'description': '090 "Consumer, customer management and service"',
                    }, {
                        'description': '098 "Business and technical information"',
                    }, {
                        'description': '148 "Online shopping and other electronic commerce services"',
                    }, {
                        'description': '152 "Management of advertisement or commercial act"',
                    }, {
                        'description': '154 "Credit check"',
                    }, {
                        'description': '157 "Investigation, statistics and research analysis"',
                    }, {
                        'description': '181 "Other business in accordance with the business registration items or articles of incorporation"',
                    }]
                }]
            }, {
                'title': 'Types of Personal Data to be collected:',
                'description': 'The types of Personal Data to be collected by Gogoro are described below in accordance with the Types Classification Guidance. However, the Personal Data to be collected by Gogoro may not be limited to the types below (such as geographic location, or data of real-time localization and mapping), and shall be subject to the Personal Data actually collected by Gogoro in the course of its business operations.',
                'sections': [{
                    'description': 'Code types of identification: C001 to C003, such as name, address, phone number, email, ID card number, credit card number, etc.',
                }, {
                    'description': 'Code type of characteristics: C011, such as age, gender, date of birth, etc.',
                }, {
                    'description': 'Code type of family: C021, C023 and C024, such as marital status, offspring, other social relations, etc.',
                }, {
                    'description': 'Code type of travel and other migrational details: C034, such as previous emigration, traveling details, foreign passport, residency proof documents, work-permission documents, working certificate and other related details.',
                }, {
                    'description': 'Code types of social connections: C035, C036, C038 and C040, such as hobbies, consumption patterns, occupation, accidents or other mishaps, relevant connections, etc.',
                }, {
                    'description': 'Code types of educational history, qualifications or expertise: C051 and C052, such as schools and qualifications for diploma, license, etc.',
                }, {
                    'description': 'Code types of employment: C061, C064 and C068, such as employer, previous employers, salaries, etc.',
                }, {
                    'description': 'Code types of financial details: C081 and C093, such as total earnings and income, methods of payment, etc.',
                }, {
                    'description': 'Code types of health and others: C114 and C115, such as records, decisions and administrative sanctions concerning traffic violations, etc.',
                }, {
                    'description': 'The user\'s geographic location.',
                }, {
                    'description': 'The user\'s real-time location.',
                }],
            }, {
                'title': 'The period, area, recipient and method of processing and use of Personal Data',
                'sections': [{
                    'description': 'Period: The duration of the specific purpose as stipulated in Article 1 of the Gogoro Privacy Policy and a reasonable period after the expiration of such duration, or the period specified in the relevant laws and regulations or contract. Gogoro reserves the right to terminate the aforementioned period.',
                }, {
                    'description': 'Area: Within the territory of Republic of China or the country or region where the "recipient" provided in Paragraph 3 below is located.',
                }, {
                    'description': 'Recipient: Gogoro, affiliates of Gogoro, or third parties commissioned by Gogoro to collect, process or use Personal Data for your or Gogoro\'s benefit, or vendors in collaboration with Gogoro, such as product and service providers of electronic motorcycle, data statistics and analysis operators, marketing companies, or any other service providers.',
                }, {
                    'description': 'Method: In oral or written form (either hard copy or soft copy), telephone, text message, email, facsimile, electronic record, digital documents, appropriate manners which meet the current technology, or any other methods in accordance with relevant laws and regulations or contract.',
                }],
            }, {
                'title': 'Your relevant rights',
                'description': 'According to Article 3 of the Taiwan Personal Data Protection Act, you may exercise the following rights with respect to your Personal Data:',
                'sections': [{
                    'description': 'For your Personal Data collected by Gogoro, you may request in writing or via email, to inquire, review or make duplicates thereof from Gogoro.',
                }, {
                    'description': 'You may request Gogoro to supplement your Personal Data, to discontinue the collection, processing or use thereof, or to correct or delete your Personal Data which is incorrect.',
                }, {
                    'description': 'If you contemplate exercising any of the rights aforementioned, please send relevant supporting documents and a written request to Gogoro at the address of No. 33, Dinghu Road, Guishan District, Taoyuan City, Taiwan or via email(contact@gogoro.com). In the event of a request to inquire, review or make duplicates of your Personal Data, Gogoro will notify you in writing or via email of its decision regarding the request within 30 days upon the receipt thereof. The 30-day period as stated above may be extended for another 30 days if necessary, at Gogoro\'s own discretion; we will notify you of such decision of extension in writing or via email.',
                }, {
                    'description': 'In the event of a request for supplement, correction, deletion or discontinuation of the collection, processing or use of your Personal Data, Gogoro will notify you in writing or via email of its decision regarding the request within 30 days upon the receipt thereof. The 30-day period as stated above may be extended for another 30 days if necessary, at Gogoro\'s own discretion; we will notify you of such decision of extension in writing or via email.',
                }, {
                    'description': 'If you request to inquire or review your Personal Data, please go to the designated location for such inquiry or review during the time period specified as indicated by Gogoro. If you have not inquired or reviewed your Personal Data within the time period, please resubmit your request to Gogoro in writing or via email. In the event of request for inquiry, review or to make duplicates of Personal Data, Gogoro may charge necessary fees.',
                }],
            }, {
                'title': 'You may also choose not to provide the above Personal Data. However, you fully understand that, if your Personal Data is not provided, Gogoro may not be able to provide you the products or services in a timely manner, or may not be able to provide the products or services to you.',
            }],
        }, {
            'title': 'Non-Personal Information Gogoro May Collect, Process and Use',
            'description': [
                'Once you use the Website/App, act on a Website/App message, or use Gogoro Product/Service ,Gogoro or Gogoro’s strategic partners may use some technologies to collect non-personal information about your usage of or activity on the Website/App or Product/Service that cannot, on its own, identify or allow direct association with a specific individual. Non-personal information may include, without limitation, information collected by or through the Website/App or Product/Service. This Website/App or Product/Service may collect information about your location. If you do not want this information collected, change the settings of the Website/App or Product/Service.',
                'Gogoro Privacy Policy does not prevent Gogoro from using or sharing any Non-personal information, and Gogoro may in its sole discretion decide whether to use or share Non-personal information with Gogoro’s strategic partners. For example, Non-personal information may be used to enhance the understanding of your usage patterns, to identify which parts of the Website is commonly used, and evaluate the effectiveness of ads.',
            ]
        }, {
            'title': 'Protecting Your Personal Information',
            'description': [
                'Gogoro will take reasonable and appropriate measures to prevent your personal information provided by you from unauthorized or unlawful access, use, processing, or alteration, and from any breaches or loss of such personal information. Such measures may be implemented through use of a third party service. You are solely responsible for any personal information you choose to share or submit in public areas of the Website or Product/Service, such as a forum or a message board.',
                'Despite Gogoro taking reasonable steps to use and improve various safeguards, you acknowledge and agree that no system or technology is completely secure and safe. If you become aware of any vulnerability of the Website, please email support.tw@ridegoshare.com or use the Website to report such vulnerability.',
            ]
        }, {
            'title': 'Updates',
            'description': [
                'Gogoro may update or upgrade from time to time the Website for providing you with additional features, addressing technical issues, and enhancing your user experience. The Website may include an automatic updates feature, which gives Gogoro the ability to make updates automatically. You can change automatic updates options by changing your settings within the Website. Under certain limited circumstances, the Website may still be automatically updated, nevertheless the status of the automatic updates setting is. For example, Gogoro may provide an automatic update to fix a security vulnerability or breach for your network.',
            ]
        }]
    },
    'cookie': {
        'subheading': 'Cookie Policy',
        'summary': [
            'Your privacy is very important to Gogoro Inc. and its affiliates and/or subsidiaries (including but not limited to Gogoro Network (Cayman), Taiwan Branch, Gogoro Taiwan Limited, Gogoro Taiwan Sales and Service Limited, GoShare Taiwan Limited and GoPocket Taiwan Limited (collectively, “Gogoro” or “Gogoro Group” or “We”), and considers it essential to inform the User in a clear and transparent way about the use of cookies while browsing on the Website and the Application.',
            'We use cookies on our Website and Application for a variety of purposes which are described in this Cookie Policy. A cookie is a small piece of data that a website stores on the visitor’s device. We are fully aware of the importance of your privacy and have taken steps to ensure that your privacy and personal data is protected and respected at all times.'
        ],
        'sections': [{
            'title': 'Categories of Cookies',
            'description': [
                'We may use some or all of the following category of cookie:'
            ],
            'sections': [{
                'title': 'Strictly necessary cookies',
                'description': [
                    'These cookies are essential in order to enable you to move around the website and use its features. Without these cookies, services you have asked for, like payment services or account authorization, cannot be provided.'
                ]
            }, {
                'title': 'Performance cookies',
                'description': [
                    'These cookies collect information about how visitors use a website, for instance which pages visitors go to most often, and if they get error messages from web pages. These cookies do not collect information that identifies a visitor. All information these cookies collect is aggregated and therefore anonymous. It is only used to improve how a website works.'
                ]
            }, {
                'title': 'Functionality cookies',
                'description': [
                    'These cookies allow the website to remember choices you make (such as your user name, language or the region you are in) and provide enhanced, more personal features. These cookies can also be used to remember changes you have to parts of web pages that you can customize. They may also be used to keep track of which notices you have already viewed to avoid repetition. The information these cookies collect will not personally identify you and cannot track your browsing activity on other websites.'
                ]
            }, {
                'title': 'Targeting cookies or advertising cookies',
                'description': [
                    'These cookies are used to deliver adverts more relevant to you and your interests. They are also used to limit the number of times you see an advertisement as well as help to measure the effectiveness of the advertising campaigns. They are usually placed by advertising networks with the website operator’s permission. They remember that you have visited a website and this information is shared with other organizations such as advertisers. Quite often targeting or advertising cookies will be linked to site functionality provided by the other organization.'
                ]
            }, {
                'title': 'Session cookies',
                'description': [
                    'Any of the above categories of cookie may be a session cookie which are temporary and only remain on your device until the visitor close the browser.'
                ]
            }, {
                'title': 'Persistent cookies',
                'description': [
                    'Any of the above categories of cookie may be a persistent cookie which will remain on the device for a predetermined period and are activated each time the visitors visit the website.'
                ]
            }]
        }, {
            'title': 'Use of First Party Cookie',
            'description': [
                'We may place and access certain first party cookies on your device. First party cookies are those placed directly by us and are fully controlled by us.',
                'The following first party cookies may be placed on your device:',
                'We do not place and access first party cookies when you browse GoShare website(https://www.ridegoshare.com)'
            ]
        }, {
            'title': 'Use of Third Party Service Providers',
            'description': [
                'In addition to first party cookies, you may also receive certain third party cookies on your device which are placed by a third party service provider other than us. Third party cookies are normally used for advertising or tracking purposes.',
                'The following third party service providers are used by us:',
                {
                    'style': 'third-party',
                    'head': [
                        'Name of Provider',
                        'Purpose & Type',
                        'Strictly Necessary',
                    ],
                    'body': [
                        [
                            'Google Analytics',
                            [
                                'Gogoro uses Google Analytics to understand the effectiveness of website marketing and user interaction with website content, in order to improve the user experience when visiting the website. Sometimes Gogoro will use the data collected by Gogoro Analytics to provide more accurate advertising.',
                                'Expiry: 730 days'
                            ],
                            'Yes'
                        ]
                    ]
                },
                {
                    'type': 'withLink',
                    'value': 'For more details about Google Analytics, please %{here}',
                    'link': {
                        'here': {
                            'type': 'outside',
                            'value': 'click here to consult Google’s privacy policy.',
                            'style': 'cookie-link',
                            'href': 'https://policies.google.com/privacy?hl=en&gl=en',
                        }
                    }
                }
            ]
        }, {
            'title': 'Consent to Cookies Collection',
            'description': [
                'We will ask for your prior consent to use the cookies (other than the strictly necessary cookies). You may withhold your consent by refusing our collection of cookies or by editing your browser settings/options to reject our cookies or to prompt you before accepting a cookie. However, if a browser does not accept cookies or if you reject a cookie, some portions of our services may not function properly.',
                'You may find additional information for how to modify your browser setting below:'
            ],
            'sections': [
                {
                    'description': [
                        'Google Chrome:',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.google.com/chrome/answer/95647?hl=en-GB',
                                    'style': 'cookie-link',
                                    'href': 'https://support.google.com/chrome/answer/95647?hl=en-GB',
                                }
                            }
                        }
                    ],
                },
                {
                    'description': [
                        'Microsoft Internet Explorer:',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d',
                                    'style': 'cookie-link',
                                    'href': 'https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d',
                                }
                            }
                        }
                    ],
                },
                {
                    'description': [
                        'Microsoft Edge:',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.microsoft.com/en-gb/products/microsoft-edge',
                                    'style': 'cookie-link',
                                    'href': 'https://support.microsoft.com/en-gb/products/microsoft-edge',
                                }
                            }
                        }
                    ],
                },
                {
                    'description': [
                        'Safari (macOS):',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.apple.com/guide/safari/welcome/14.0/mac/11.0',
                                    'style': 'cookie-link',
                                    'href': 'https://support.apple.com/guide/safari/welcome/14.0/mac/11.0',
                                }
                            }
                        }
                    ],
                },
                {
                    'description': [
                        'Safari (iOS):',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.apple.com/en-gb/HT201265',
                                    'style': 'cookie-link',
                                    'href': 'https://support.apple.com/en-gb/HT201265',
                                }
                            }
                        }
                    ],
                },
                {
                    'description': [
                        'Mozilla Firefox:',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.mozilla.org/en-US/products/firefox/protect-your-privacy/cookies',
                                    'style': 'cookie-link',
                                    'href': 'https://support.mozilla.org/en-US/products/firefox/protect-your-privacy/cookies',
                                }
                            }
                        }
                    ],
                },
                {
                    'description': [
                        'Android:',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DAndroid&hl=en',
                                    'style': 'cookie-link',
                                    'href': 'https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DAndroid&hl=en',
                                }
                            }
                        }
                    ],
                }
            ]
        }, {
            'title': 'Changes',
            'description': [
                'We may change this Cookie Policy from time to time. Any such changes will become binding on you on your first use of our website after the changes have been made. You are therefore advised to check this Cookie Policy regularly.'
            ]
        },{
            'title': 'Further Information',
            'description': [
                {
                    'type': 'withLink',
                    'value': 'If you are interested in how we use and protect your personal data other than cookies, please find our Privacy Policy %{here}.',
                    'link': {
                        'here': {
                            'type': 'inside',
                            'value': 'here',
                            'style': 'cookie-link',
                            'href': '/privacy',
                        }
                    }
                },
                'If you have any questions about this Cookie Policy, please contact us at dataprivacy@gogoro.com'
            ]
        }]
    },
    'copyright': [
        '© 2022 Gogoro and/or its affiliates. All rights reserved.',
    ],
};

export default lang;
